import config, {weather_base_url} from "../config"
const baseUrl = config.weather_base_url + "region/"
export default {
    // 一次性加载省市区三级联动数据（树形结构，精简版）
    areaTree: {
        url: baseUrl + "areaTree",
        type: "get",
    },
    // 获取省份列表
    provinceList: {
        url: baseUrl + "provinceList",
        type: "get",
    },
    // 获取城市列表
    cityList: {
        url: baseUrl + "cityList",
        type: "get",
    },
    // 获取区县列表
    districtList: {
        url: baseUrl + "districtList",
        type: "get",
    },
    // 根据ID获取大区信息
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    // 获取所有大区列表
    findAll: {
        url: baseUrl + "findAll",
        type: "get",
    },
    // 分页查询大区
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    // 保存或更新大区信息（不包含区县关联）
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    // 保存或更新大区信息（包含区县关联）
    saveWithDistricts: {
        url: baseUrl + "saveWithDistricts",
        type: "post",
    },
    // 删除大区
    delete: {
        url: baseUrl + "delete",
        type: "get",
    },
    // 获取大区关联的区县列表
    getRegionDistricts: {
        url: baseUrl + "getRegionDistricts",
        type: "get",
    },
    // 批量添加大区区县关联
    addDistricts: {
        url: baseUrl + "addDistricts",
        type: "post",
    },
    // 删除大区区县关联
    deleteDistrict: {
        url: baseUrl + "deleteDistrict",
        type: "get",
    }
}

